(() => {
  const init = (root) => {
    if (!root || root.dataset.mj88OffersReady === 'true') return;

    // Keep Horizon's native product block mounted so the variant picker and EasySell app block remain available.
    const originalProductInfo = document.querySelector('[data-testid="product-information"]');
    const originalProductSection = originalProductInfo && originalProductInfo.closest('.shopify-section');
    if (originalProductSection) {
      originalProductSection.style.setProperty('display', 'none', 'important');
    }

    root.dataset.mj88OffersReady = 'true';

    const offerButtons = Array.from(root.querySelectorAll('button[data-mj88-offer]'));
    const orderButtons = Array.from(root.querySelectorAll('[data-mj88-order-cta]'));
    const status = root.querySelector('[data-mj88-easysell-status]');

    const selectedOffer = () =>
      offerButtons.find((button) => button.getAttribute('aria-pressed') === 'true') ||
      offerButtons[0];

    const updateOfferLabel = () => {
      const selected = selectedOffer();
      if (!selected) return;

      const message = selected.dataset.mj88Offer === '2'
        ? 'جوج قطع — 175 درهم (توفير 55 درهم).'
        : 'قطعة وحدة — 115 درهم.';

      const summary = root.querySelector('[data-mj88-offer-summary]');
      if (summary) summary.textContent = message;
    };

    const selectShopifyVariant = (button) => {
      const variantId = button && button.dataset.mj88VariantId;
      if (!variantId) return;

      const variantInput = document.querySelector(
        'variant-picker input[data-variant-id="' + variantId + '"]'
      );

      if (variantInput && !variantInput.checked) {
        variantInput.click();
      }
    };

    const nextPaint = () => new Promise((resolve) => {
      window.requestAnimationFrame(() => window.requestAnimationFrame(resolve));
    });

    // Wait for EasySell to inject its own button, then trigger that real button.
    const waitForAndClickEasySell = (timeoutMs = 15000) => new Promise((resolve) => {
      let observer = null;
      let timer = null;
      let settled = false;

      const cleanup = () => {
        if (observer) {
          observer.disconnect();
          observer = null;
        }
        if (timer) {
          window.clearTimeout(timer);
          timer = null;
        }
      };

      const finish = (result) => {
        if (settled) return;
        settled = true;
        cleanup();
        resolve(result);
      };

      const tryClick = () => {
        // EasySell renders two #es-popup-button elements (cart drawer + product). Target the product one.
        const easySellButton = document.querySelector('#es-popup-button.es-popup-button-product') ||
          document.querySelector('.es-popup-button-product');
        if (!easySellButton || easySellButton.disabled ||
            easySellButton.getAttribute('aria-disabled') === 'true') {
          return false;
        }

        easySellButton.click();
        finish(true);
        return true;
      };

      // First try immediately; if EasySell has not loaded yet, observe the DOM.
      if (tryClick()) return;

      observer = new MutationObserver(() => {
        tryClick();
      });

      observer.observe(document.documentElement || document.body, {
        childList: true,
        subtree: true,
        attributes: true,
        attributeFilter: ['disabled', 'aria-disabled']
      });

      timer = window.setTimeout(() => finish(tryClick()), timeoutMs);
    });

    offerButtons.forEach((button) => {
      button.addEventListener('click', () => {
        offerButtons.forEach((candidate) => {
          const isSelected = candidate === button;
          candidate.classList.toggle('is-selected', isSelected);
          candidate.setAttribute('aria-pressed', isSelected ? 'true' : 'false');
        });

        selectShopifyVariant(button);
        updateOfferLabel();

        if (status) status.textContent = '';
      });
    });

    orderButtons.forEach((button) => {
      button.addEventListener('click', async (event) => {
        event.preventDefault();
        if (button.dataset.mj88Busy === 'true') return;

        button.dataset.mj88Busy = 'true';
        button.setAttribute('aria-busy', 'true');
        if (status) status.textContent = '';

        try {
          // Re-assert the chosen Shopify variant before EasySell reads the product.
          selectShopifyVariant(selectedOffer());
          await nextPaint();

          const opened = await waitForAndClickEasySell();
          if (!opened && status) {
            status.textContent = 'الفورم ما تحمّلش. عاود المحاولة بعد لحظة.';
          }
        } finally {
          button.dataset.mj88Busy = 'false';
          button.removeAttribute('aria-busy');
        }
      });
    });

    const currentVariant = document.querySelector(
      'variant-picker input[data-variant-id]:checked'
    );

    if (currentVariant) {
      const currentOffer = offerButtons.find(
        (button) => button.dataset.mj88VariantId === currentVariant.dataset.variantId
      );

      if (currentOffer) {
        offerButtons.forEach((candidate) => {
          const isSelected = candidate === currentOffer;
          candidate.classList.toggle('is-selected', isSelected);
          candidate.setAttribute('aria-pressed', isSelected ? 'true' : 'false');
        });
      }
    }

    updateOfferLabel();
  };

  const run = () => {
    document.querySelectorAll('.mj88-landing').forEach(init);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run, { once: true });
  } else {
    run();
  }
})();
